import { render, staticRenderFns } from "./SuccessScreen.vue?vue&type=template&id=5a2684dd&scoped=true"
import script from "./SuccessScreen.vue?vue&type=script&lang=js"
export * from "./SuccessScreen.vue?vue&type=script&lang=js"
import style0 from "./SuccessScreen.vue?vue&type=style&index=0&id=5a2684dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2684dd",
  null
  
)

export default component.exports